// extracted by mini-css-extract-plugin
export default {"productGallery":"KG-z","inQuickShop":"LG-z"};